export const GET_GIT_VERSION = 'general/getGitVersion';
export const GET_STATISTICAL_DATA = 'general/getStatisticalData';
